import { render, staticRenderFns } from "./LiveTime.vue?vue&type=template&id=3060e197&"
import script from "./LiveTime.vue?vue&type=script&lang=js&"
export * from "./LiveTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports